import classNames from 'classnames';
import React from 'react';

import Slides from 'common/components/RewindModal/Slides';

import styles from '../styles.module.scss';
import BottomActions from './component/BottomActions';

type ScreenConclusionProps = {
  onNext: () => void;
  isLastStep: boolean;
  trackingScreenName?: string;
};

const ScreenConclusion = ({ onNext, isLastStep }: ScreenConclusionProps) => {
  const title = 'Ce flashback, c’est du Inception !';
  const subtitle =
    'une plongée dans vos meilleurs souvenirs. Partagez-le à vos proches.';

  return (
    <Slides>
      <div className={classNames(styles.contentLayout, styles.startLayout)}>
        <h2 className={styles.introTitle}>{title}</h2>
        <h3 className={styles.slideText}>{subtitle}</h3>
      </div>
      <BottomActions
        showShare={false}
        showNext={!isLastStep}
        onNextClick={onNext}
      />
    </Slides>
  );
};

export default ScreenConclusion;
